module.exports = __webpack_public_path__ + "static/img/x7.09aac71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/x7.jpg
// module id = 76DR
// module chunks = 4